import React from 'react';
import { Svg } from './iconPrimitives';

export { CategoryGlyph } from './CategoryGlyph';

export function ChevronRight({ className, size = 16 }) {
  return (
    <Svg className={className} size={size}>
      <path d="m9 6 6 6-6 6" />
    </Svg>
  );
}

export function ChevronDown({ className, size = 16 }) {
  return (
    <Svg className={className} size={size}>
      <path d="m6 9 6 6 6-6" />
    </Svg>
  );
}

export function PrepWater({ className, size = 32 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M12 3s6 6 6 11a6 6 0 1 1-12 0c0-5 6-11 6-11Z" />
    </Svg>
  );
}

export function PrepMilk({ className, size = 32 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M8 4h8l1 4v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8l1-4Z" />
      <path d="M8 8h8" />
    </Svg>
  );
}

export function PrepBoth({ className, size = 32 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M7 4s4 4 4 8a4 4 0 1 1-8 0c0-4 4-8 4-8Z" />
      <path d="M15 6h5l1 3v8a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V9l1-3Z" />
    </Svg>
  );
}

export function BrewTemp({ className, size = 20 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M14 4v10.5a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z" />
      <path d="M10 4h4" />
    </Svg>
  );
}

export function BrewTime({ className, size = 20 }) {
  return (
    <Svg className={className} size={size}>
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9v5l3 2" />
    </Svg>
  );
}

export function BrewAmount({ className, size = 20 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M6 3v11c0 3 2.5 5 6 5s6-2 6-5V3" />
      <path d="M6 3h12" />
      <path d="M9 3v3c0 1.5 1 2.5 3 2.5s3-1 3-2.5V3" />
    </Svg>
  );
}

export function IconAlert({ className, size = 40 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M12 4 3 19h18L12 4Z" />
      <path d="M12 9v5" />
      <path d="M12 17h.01" />
    </Svg>
  );
}

export function IconCart({ className, size = 20 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M6 6h15l-2 9H8L6 6Z" />
      <path d="M6 6 5 3H2" />
      <circle cx="9" cy="20" r="1" />
      <circle cx="18" cy="20" r="1" />
    </Svg>
  );
}

export function IconInfo({ className, size = 16 }) {
  return (
    <Svg className={className} size={size}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16v-5" />
      <path d="M12 8h.01" />
    </Svg>
  );
}

export function PrepBadgeWater({ className, size = 14 }) {
  return <PrepWater className={className} size={size} />;
}

export function PrepBadgeMilk({ className, size = 14 }) {
  return <PrepMilk className={className} size={size} />;
}

/** Curated / signature accent for headings and match callouts */
export function IconSparkle({ className, size = 18 }) {
  return (
    <Svg className={className} size={size}>
      <path d="M12 2v4M12 18v4M4.5 4.5l2.8 2.8M16.7 16.7l2.8 2.8M2 12h4M18 12h4M4.5 19.5l2.8-2.8M16.7 7.3l2.8-2.8" />
    </Svg>
  );
}
